import React from "react";

import { Icon } from "@culturehq/components";

import { Template } from "chq";
import { Trans } from "app/utils";

interface TemplateProps {
  selectedTemplate?: Template;
}

const TemplateTitle: React.FC<TemplateProps> = ({ selectedTemplate }) => (
  <h2 className="Stories-Container__Title">
    {!selectedTemplate
      ? <Icon className="Required-Icon" icon="info" />
      : <Icon className="Completed-Icon" icon="ios-checkmark" />}
    <Trans>Select a template</Trans>
  </h2>
);

export default TemplateTitle;
